/* Noble & Sunday: isolated drawer; native cart remains the no-JavaScript fallback. */
(() => {
  'use strict';
  const drawer = document.getElementById('ns-cart');
  if (!drawer || !drawer.showModal || !window.fetch) return;
  const content = document.getElementById('ns-cart-content');
  const message = document.getElementById('ns-cart-message');
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let busy = false, previousFocus, previousOverflow, notePending = Promise.resolve();
  const cartPath = new URL(root + 'cart', location.origin).pathname;
  function open() {
    if (drawer.open) return;
    previousFocus = document.activeElement;
    const closeHeader = document.querySelector('.site-header.active [data-close-header]');
    if (closeHeader) closeHeader.click();
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    drawer.showModal();
    drawer.querySelector('[data-ns-close]')?.focus();
  }
  drawer.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  });
  function notice(text) { message.textContent = text; }
  function lock(value) {
    busy = value;
    content.setAttribute('aria-busy', String(value));
    content.querySelectorAll('button:not([data-ns-close]),input,textarea').forEach(el => el.disabled = value);
  }
  async function request(url, options) {
    const response = await fetch(url, Object.assign({credentials:'same-origin',cache:'no-store'}, options));
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your cart. Please try again.');
    return data;
  }
  function render(html) {
    const doc = new DOMParser().parseFromString(html || '', 'text/html');
    const fresh = doc.querySelector('[data-ns-cart-content]');
    if (!fresh) throw new Error('Your cart could not be displayed. Please use View full cart below.');
    const scroll = content.querySelector('.ns-cart__scroll')?.scrollTop || 0;
    content.replaceChildren(fresh);
    const scroller = content.querySelector('.ns-cart__scroll');
    if (scroller) scroller.scrollTop = scroll;
    document.querySelectorAll('#CartCount').forEach(el => el.textContent = fresh.dataset.count);
  }
  async function refresh() {
    const url = new URL(root + 'cart', location.origin);
    url.searchParams.set('sections','ns-cart-drawer');
    const data = await request(url.toString());
    render(data['ns-cart-drawer']);
  }
  async function run(operation) {
    if (busy) return;
    notice(''); lock(true);
    try { await operation(); }
    catch (error) { notice(error.message || 'Unable to update your cart. Please try again.'); }
    finally { lock(false); }
  }
  async function mutate(endpoint, data) {
    await notePending;
    data.sections = 'ns-cart-drawer'; data.sections_url = cartPath;
    const result = await request(root + 'cart/' + endpoint + '.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)});
    if (result.sections?.['ns-cart-drawer']) render(result.sections['ns-cart-drawer']);
    else await refresh();
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || drawer.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || url.pathname.replace(/\/$/,'') !== cartPath) return;
    event.preventDefault(); event.stopImmediatePropagation(); open(); run(refresh);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || drawer.contains(form)) return;
    const url = new URL(form.action, location.origin);
    if (url.origin !== location.origin || !/\/cart\/add\/?$/.test(url.pathname)) return;
    // Buy-it-now and accelerated checkout keep their native flow.
    if (event.submitter?.closest('.shopify-payment-button')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (!form.reportValidity() || busy) return;
    const data = new FormData(form);
    data.set('sections','ns-cart-drawer'); data.set('sections_url',cartPath);
    open();
    run(async () => {
      const result = await request(root + 'cart/add.js',{method:'POST',body:data});
      try {
        if (result.sections?.['ns-cart-drawer']) render(result.sections['ns-cart-drawer']);
        else await refresh();
      } catch (_) { throw new Error('Item added, but the cart could not refresh. Use View full cart below; do not add it again.'); }
    });
  }, true);
  drawer.addEventListener('click', event => {
    if (event.target === drawer) { const r = drawer.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right) drawer.close(); }
    if (event.target.closest('[data-ns-close]')) drawer.close();
    const control = event.target.closest('[data-ns-quantity]');
    if (!control || busy) return;
    const row = control.closest('[data-key]');
    const index = Array.from(content.querySelectorAll('[data-key]')).indexOf(row);
    run(async () => {
      await mutate('change',{id:row.dataset.key,quantity:Number(control.dataset.nsQuantity)});
      const rows = content.querySelectorAll('[data-key]');
      (rows[Math.min(index,rows.length-1)]?.querySelector('[data-ns-input]') || content.querySelector('[data-ns-close]'))?.focus();
    });
  });
  drawer.addEventListener('change', event => {
    if (!event.target.matches('[data-ns-input]')) return;
    const input = event.target, quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 0 || input.value === '') {input.value = input.defaultValue;return;}
    const index = Array.from(content.querySelectorAll('[data-ns-input]')).indexOf(input);
    run(async () => {
      await mutate('change',{id:input.closest('[data-key]').dataset.key,quantity});
      (content.querySelectorAll('[data-ns-input]')[index] || content.querySelector('[data-ns-close]'))?.focus();
    });
  });
  // Save notes without replacing the focused field; the checkout form also submits the note.
  drawer.addEventListener('focusout', event => {
    if (event.target.id !== 'ns-cart-note') return;
    const note = event.target.value;
    notePending = request(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note})}).catch(() => notice('Your note will be saved when you continue to checkout.'));
  });
  drawer.addEventListener('submit', event => {if (busy) event.preventDefault();});
})();
